module.exports = __webpack_public_path__ + "media/images/log/log-map-ca0db474b4eef64d58e4f08df8331855.svg";